import React from 'react'
import createReactClass from 'create-react-class'

import i18n from 'live/services/i18n'
import xhr from 'live/services/xhr'
import StatsBase from 'live/components/extensions/ui/stats'

var View = createReactClass({
    getInitialState: function() {
        return {
            instance: {}
        }
    },
    UNSAFE_componentWillMount: function() {
        this.fetch(this.props.id)
    },
    UNSAFE_componentWillReceiveProps: function(newProps) {
        var id = newProps.id
        var currentId = this.props.id

        if (id !== currentId) this.fetch(id)
    },
    fetch: function(id) {
        xhr.get('/rest/extension/' + id).then(this.setInstance)
    },
    setInstance: function(resp) {
        this.setState({
            instance: resp.data
        })
    },
    render: function() {
        var instance = this.state.instance
        console.log('instance = ', instance)
        var info = [
            {
                label: i18n('URL'),
                value: instance.config && instance.config.url
            },
            {
                label: i18n('URL'),
                value: instance.config && instance.config.authUrl
            },
            {
                label: i18n('User'),
                value: instance.config && instance.config.user
            },
            {
                label: i18n('Password'),
                value: instance.config && instance.config.password
            },
            {
                label: i18n('Client ID'),
                value: instance.config && instance.config.clientId
            },
            {
                label: i18n('BOP Test Id on SIP'),
                value: instance.config && instance.config.BOPTestSISPId
            },
            {
                label: i18n('SIP Types'),
                value: instance.config && instance.config.SISPTypes
            }
        ]

        return <StatsBase {...this.props} noFetch={true} instance={instance} info={info} />
    }
})

module.exports = View
